<mat-expansion-panel [expanded]="initialExpanded" (opened)="toggleExpanded()" (closed)="toggleExpanded()">
    <mat-expansion-panel-header>
        <mat-panel-title>MEDIA</mat-panel-title>
    </mat-expansion-panel-header>
    <div class="panel-info">
        <ng-container *ngIf="patientMedia; else listLoading">
            <ng-container *ngIf="patientMedia.length; else noResults">
                <app-file-gallery [fileObjects]="patientMedia" [deleteEnabled]="false" [ignoreSorting]="true"
                    [enableEditing]="true"></app-file-gallery>
            </ng-container>
        </ng-container>
    </div>
</mat-expansion-panel>

<ng-template #listLoading>
    <div class="list-loading">
        <mat-spinner color="primary" mode="indeterminate" diameter="20" style="float:right;"></mat-spinner>
    </div>
</ng-template>

<ng-template #noResults>
    <p class="no-records-message">No results found.</p>
</ng-template>